import store from '../store/index'

import subDepartmentsActionCreators from "../store/sub-departments/action-creators";
import formsActions from "../store/forms/action-creators";
import commonActions from "../../shared/store/common/action-creators";
import testsActions from "../store/tests/action-creators";

//add fetch by role
const initApp = () => Promise.all([
  store.dispatch(subDepartmentsActionCreators.fetchSubDepartments()),
  store.dispatch(formsActions.fetchForms()),
  store.dispatch(commonActions.fetchFormTypes()),
  store.dispatch(testsActions.fetchTestsForGrade())
]);

export {
  initApp
}
